import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = hash.split('session_id=')[1]?.split('&')[0];

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    // Exchange session_id — backend sets httpOnly cookie
    axios.post(`${API}/auth/google/session`, { session_id: sessionId }, { withCredentials: true })
      .then(({ data }) => {
        // Store token in localStorage as backup, cookie is primary
        if (data.token) sessionStorage.setItem('aira_session', data.token);
        const dest = data.role === 'broker' ? '/broker' : '/today';
        window.history.replaceState(null, '', dest);
        window.location.reload();
      })
      .catch((err) => {
        console.error('OAuth callback failed:', err?.response?.data || err.message);
        const detail = err?.response?.data?.detail;
        const msg = typeof detail === 'string' ? detail : 'Google sign-in failed. Please try again.';
        navigate(`/login?error=${encodeURIComponent(msg)}`, { replace: true });
      });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#F5F7FA' }}>
      <div className="text-center">
        <span className="text-3xl tracking-[0.08em] uppercase font-bold" style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}>
          <span style={{ color: '#0B1E3D' }}>fr</span>
          <span style={{ background: 'linear-gradient(135deg, #FFC46B, #FF9A26, #F27500)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>AI</span>
          <span style={{ color: '#0B1E3D' }}>me</span>
        </span>
        <p className="mt-3 text-sm" style={{ color: '#5C6B7A' }}>Signing you in...</p>
      </div>
    </div>
  );
}
